import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {BenefitInfo} from 'main/stores/benefits';

class BenefitInfoChangeRequest extends DomainObject {
  effectiveDate;
  reasonForChange;
  reasonText;
  benefitInfoChanges;
  updatedBenefitInfo;

  _relations = {
    _dates: ['effectiveDate'],
    updatedBenefitInfo: BenefitInfo,
    reasonForChange: oneOf([
      'child_birth',
      'marriage',
      'divorce',
      'cohabitation',
      'student_status',
      'other'
    ])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      effectiveDate: observable,
      reasonForChange: observable,
      reasonText: observable,
      benefitInfoChanges: observable,
      updatedBenefitInfo: observable,
      otherReason: computed
    });

    this.merge(other);
  }

  get otherReason() {
    return this.reasonForChange === 'other';
  }
}

export default BenefitInfoChangeRequest;
